<template>
  <div class="mode">
    <vue-feather type="moon" v-show="mixLayout == 'light-only'" @click="customizeMixLayout('dark-only')"></vue-feather>
    <vue-feather type="moon" v-show="mixLayout == 'dark-only'" @click="customizeMixLayout('light-only')"></vue-feather>
  </div>
</template>
  
<script>
export default {
  name: 'modePage',
  data() {
    return {
      darkMode: false,
      mixLayout: 'light-only',
      actives: false,
    };
  },
  methods: {
    customizeMixLayout(val) {
      this.mixLayout = val;
      this.$store.dispatch('layout/setLayout',  val);
    },
  },
  mounted() {
    const savedMode = localStorage.getItem('mode');
    if (savedMode) {
      this.mixLayout = savedMode;
      this.actives = savedMode === 'dark-only';
      this.$store.dispatch('layout/setLayout', savedMode);
    }
  },
  watch: {
    mixLayout(newValue) {
      localStorage.setItem('mode', newValue);
    },
  },
};
</script>